import React from "react";

import { readDataFromLocalStorage } from "../utils/globalUtils";

function withRbac(Component) {
  return function(props) {
    const userPermissions = readDataFromLocalStorage(
      "revvsalesUserPermissions",
    );
    return userPermissions &&
      userPermissions.find(
        permission => permission.name === props.permission,
      ) ? (
      <Component {...props} />
    ) : null;
  };
}

export default withRbac;



// WEBPACK FOOTER //
// ./src/app/withRbac.js